module.exports = __webpack_public_path__ + "static/media/edit2.a7e247fc.svg";